import IMask from 'imask/esm/imask.js';
import 'imask/esm/masked/pattern.js';
export default IMask;
//# sourceMappingURL=index.js.map